import React from "react";
import SimpleCRUD from "../../components/SimpleCRUD";

export default function Divisi() {
  return (
    <SimpleCRUD
      title="Management Divisi"
      endpoint="/divisi"
      testidPrefix="divisi"
      fields={[
        { key: "nama", label: "Nama Divisi", required: true },
        { key: "keterangan", label: "Keterangan", type: "textarea" },
      ]}
    />
  );
}
